module.exports = __webpack_public_path__ + "img/share-dialog-icon.c5a67bb3.png";